import React from "react";
import CommonDataTable from "../../../components/Datatable/CommonDataTable";
import Moment from "react-moment";
import { handleChangeTableCheckbox } from "../../../helpers/handleFormChanges";
import { AppContext } from "../../../contexts/AppContext";
import CommonDropdown from "../../../components/dropdown/CommonDropdown";
import DropdownButton from "../../../components/dropdown/DropdownButton";
import Badge from "../../../components/Common/Badge";
import ButtonRounded from "../../../components/buttons/ButtonRounded";
import Format from "../../../helpers/Format";
import { formataData } from "../../../helpers/mesesHelper";
import PropTypes from "prop-types";

function ConsultarCobrancasDataTable({
  linhas,
  checkboxesHook,
  togDownloadEmMassaModal,
  togEnviarEmailModal,
  togInformarPagamentoModal,
  togVisualizarDocumentoModal,
  solicitarCancelamento,
  cancelarCobranca,
}) {
  const { session } = React.useContext(AppContext);
  const { checkboxesMarcados, setCheckboxesMarcados } = checkboxesHook;

  const colunas = React.useMemo(
    () => [
      {
        Header: "",
        accessor: "uid",
        disableSortBy: true,
        Cell: ({ row }) => (
          <input
            className="form-check-input"
            type="checkbox"
            name="nfs"
            value={row.original.uid}
            checked={checkboxesMarcados.includes(row.original.uid)}
            onChange={(e) => {
              handleChangeTableCheckbox(
                e,
                checkboxesMarcados,
                setCheckboxesMarcados
              );
            }}
          />
        ),
      },
      {
        Header: "Cliente",
        accessor: "cliente",
      },
      {
        Header: "Valor",
        accessor: (row) => {
          return Format.formataValor(row.valor_total);
        },
      },
      {
        Header: "Vencimento",
        accessor: (row) => {
          return formataData(row.data_vencimento);
        },
      },
      {
        Header: "Valor pago",
        accessor: (row) => {
          return Format.formataValor(row.valor_pago ?? 0);
        },
      },
      {
        Header: "Status",
        disableSortBy: true,
        Cell: ({ row }) => {
          let status = [];
          var data_vencimento = new Date(row.original.data_vencimento);
          var dia_atual = new Date();
          data_vencimento.setDate(data_vencimento.getDate() + 1);

          if (row.original.status !== 4) {
            if (!row.original.valor_pago) {
              if (dia_atual < data_vencimento)
                status.push(
                  <div>
                    <Badge color="warning">Pendente</Badge>
                  </div>
                );
              else
                status.push(
                  <div>
                    <Badge color="danger">Vencido</Badge>
                  </div>
                );
            } else {
              status.push(
                <div>
                  <Badge color="success">
                    Pago em:{" "}
                    <Moment format="DD/MM/YYYY">
                      {row.original.data_pagamento}
                    </Moment>
                  </Badge>
                </div>
              );
            }
          }

          if (row.original.status === 4 && row.original.status_boleto !== 3)
            status.push(
              <div>
                <Badge color="primary">Cancelamento solicitado</Badge>
              </div>
            );

          if (row.original.status_nfse === "CANCELADO")
            status.push(
              <div>
                <Badge color="secondary">NFS-e cancelada</Badge>
              </div>
            );

          if (row.original.status_boleto === 3)
            status.push(
              <div>
                <Badge color="secondary">Boleto cancelado</Badge>
              </div>
            );

          switch (row.original.motivo_cancelamento) {
            case 1:
              status.push(
                <div>
                  <Badge color="primary">A pedido do cliente</Badge>
                </div>
              );
              break;

            case 2:
              status.push(
                <div>
                  <Badge color="primary">Substituição</Badge>
                </div>
              );
              break;

            case 3:
              status.push(
                <div>
                  <Badge color="primary">Pago direto ao cliente</Badge>
                </div>
              );
              break;

            default:
              break;
          }

          return (
            <div>
              <div className="mb-2" role="group">
                {status}
              </div>
            </div>
          );
        },
      },
      {
        Header: "Ações",
        disableSortBy: true,
        Cell: ({ row }) => {
          var status = [];
          if (row.original.status_nfse === "CONCLUIDO")
            status.push(
              <DropdownButton
                key={`visualizar-${row.original.uid}`}
                onClick={() => {
                  togVisualizarDocumentoModal(row.original.uid, "NFSE");
                }}
                color="primary"
                icon="mdi mdi-file-search"
              >
                Visualizar NFS-e
              </DropdownButton>
            );

          if (
            row.original.status_boleto === 1 ||
            row.original.status_boleto === 2
          )
            status.push(
              <DropdownButton
                key={`visualizar-boleto-${row.original.uid}`}
                onClick={() => {
                  togVisualizarDocumentoModal(row.original.uid, "BOLETO");
                }}
                color="success"
                icon="mdi mdi-credit-card-search"
              >
                Visualizar Boleto
              </DropdownButton>
            );

          if (row.original.status < 4) {
            status.push(
              <DropdownButton
                key={`enviar-email-${row.original.uid}`}
                onClick={() => {
                  togEnviarEmailModal(row.original.uid, row.original.emails);
                }}
                color="info"
                icon="mdi mdi-email-send"
              >
                Enviar e-mail
              </DropdownButton>
            );
            status.push(
              <DropdownButton
                key={`alterar-pagamento-${row.original.uid}`}
                onClick={() => {
                  togInformarPagamentoModal(
                    row.original.uid,
                    row.original.valor_total,
                    !!row.original.valor_pago
                  );
                }}
                color="warning"
                icon="mdi mdi-cash-check"
              >
                {row.original.valor_pago
                  ? "Cancelar pagamento"
                  : "Informar pagamento"}
              </DropdownButton>
            );
          }

          if (
            (row.original.status_boleto !== 3 || row.original.status !== 4) &&
            row.original.status !== 4
          )
            status.push(
              <DropdownButton
                key={`solicitar-cancelamento-${row.original.uid}`}
                onClick={() => {
                  solicitarCancelamento(row.original.uid);
                }}
                color="danger"
                icon="mdi mdi-cash-remove"
              >
                Solicitar cancelamento
              </DropdownButton>
            );

          if (
            session.codigo === "99" &&
            row.original.status === 4 &&
            row.original.status_boleto !== 3
          )
            status.push(
              <DropdownButton
                key={`cancelar-${row.original.uid}`}
                onClick={() => {
                  cancelarCobranca(row.original.uid);
                }}
                color="danger"
                icon="mdi mdi-delete"
              >
                Cancelar
              </DropdownButton>
            );
          return status.length > 0 && <CommonDropdown>{status}</CommonDropdown>;
        },
      },
    ],
    [
      cancelarCobranca,
      checkboxesMarcados,
      session.codigo,
      setCheckboxesMarcados,
      solicitarCancelamento,
      togEnviarEmailModal,
      togInformarPagamentoModal,
      togVisualizarDocumentoModal,
    ]
  );

  return (
    <CommonDataTable
      colunas={colunas}
      linhas={linhas}
      botoes={
        <ButtonRounded onClick={togDownloadEmMassaModal} color="success">
          Download em massa
        </ButtonRounded>
      }
    />
  );
}

ConsultarCobrancasDataTable.propTypes = {
  linhas: PropTypes.arrayOf(PropTypes.object).isRequired,
  checkboxesHook: PropTypes.shape({
    checkboxesMarcados: PropTypes.arrayOf(PropTypes.string).isRequired,
    setCheckboxesMarcados: PropTypes.func.isRequired,
  }).isRequired,
  togDownloadEmMassaModal: PropTypes.func.isRequired,
  togEnviarEmailModal: PropTypes.func.isRequired,
  togInformarPagamentoModal: PropTypes.func.isRequired,
  togVisualizarDocumentoModal: PropTypes.func.isRequired,
  solicitarCancelamento: PropTypes.func.isRequired,
  cancelarCobranca: PropTypes.func.isRequired,
  row: PropTypes.object,
};

export default ConsultarCobrancasDataTable;
